import { atom } from 'jotai';

export const chatIdAtom = atom<string | null>(null);

export const isS2SAtom = atom<boolean>(false);
